// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"1ff75f2d","167":"36ce409f","214":"b39a97d6","458":"3c5aff4c","561":"44ac7b17","577":"66801e42","652":"256a6b6e","682":"d5252985","783":"c66ca607","795":"fbaf76be","812":"a8661619","867":"200e4fce","904":"538f6d3c","985":"de897744","997":"f487d4a9"}[chunkId] + ".js";
};